// @owners { team: patients }
import { useNavigationContext } from '~web/contexts';

const isProgynyWizardRoute = (pathname: string | null | undefined) => {
  // The Progyny wizard screens live under /checkout/progyny-wizard/*, and the order-early screens
  // under /prescriptions/:prescriptionID/order-early[/submit]. On these screens the global Alto web
  // header is hidden in favor of the in-page Progyny branding. Other Progyny routes (e.g. the
  // /start/progyny landing page) keep the standard header and are intentionally not matched here.
  return Boolean(pathname && (pathname.includes('/checkout/progyny-wizard') || pathname.includes('/order-early')));
};

export const useIsProgynyWizardRoute = () => {
  // Only the CURRENT path matters: the global header should be hidden while on a Progyny wizard
  // screen and reappear as soon as you navigate away (e.g. back to home). Checking the previous path
  // too would keep it hidden on the next screen after leaving the flow.
  const { current } = useNavigationContext();

  return {
    isProgynyWizardRoute: isProgynyWizardRoute(current?.pathname),
  };
};
